import React, {useEffect} from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import LoginScreen from '../screens/login/LoginScreen';
import Rnd from '../screens/rnd/Rnd';
import {useDispatch, useSelector} from 'react-redux';
import {
   getIsTabletPortrait,
   getShowLandscapeMsg,
   selectLandscapeSmallWebView,
   selectScreenOrientation,
   setIsLandscapeSmallWebView,
   setIsLandscapemode,
   setIsTabletPortrait,
} from '../redux/slices/ScreenOrientationSlice';
import {Dimensions, Platform, View} from 'react-native';
import {
   isMobileWeb,
   rotateDeviceMsg,
   webLandscapeViewStyle,
} from '../utils/utils';
import CustomToast from '../components/custom-toast/index.web';
import {isTablet} from 'react-device-detect';
import {isMobileOnly} from 'react-device-detect';

const Stack = createNativeStackNavigator();
// Used for unauthenticated users of the app.
const AuthNavigator = () => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const showLandscapeMsg = useSelector(getShowLandscapeMsg);
   const isTabletPortraitMode = useSelector(getIsTabletPortrait);
   const dispatch = useDispatch();
   useEffect(() => {
      const isLandscapeListener = Dimensions.addEventListener(
         'change',
         ({window}) => {
            const screenWidth = Dimensions.get('window').width;
            const screenHeight = Dimensions.get('window').height;
            const isLandscapeModePayload = {
               isLandscapemode:
                  !isMobileOnly && screenWidth > screenHeight // ||
                     ? true
                     : false,
            };
            const isLandscapeSmallWebViewPayload = {
               isLandscapeSmallWebView:
                  isMobileOnly &&
                  Math.max(screenHeight, screenWidth) > 450 &&
                  screenHeight < screenWidth,
            };
            const isTabletPortraitPayload = {
               isTabletPortrait: isTablet && screenHeight > screenWidth,
            };
            if (Platform.OS === 'web') {
               dispatch(setIsLandscapemode(isLandscapeModePayload));
               dispatch(
                  setIsLandscapeSmallWebView(isLandscapeSmallWebViewPayload),
               );
               dispatch(setIsTabletPortrait(isTabletPortraitPayload));
            }
         },
      );
      return () => {
         isLandscapeListener.remove();
      };
   }, []);
   return (
      <View>
         <Stack.Navigator initialRouteName="Login">
            <Stack.Screen
               name="Login"
               component={LoginScreen}
               options={{headerShown: false, title: 'Login'}}
            />
            <Stack.Screen
               name="Rnd"
               component={Rnd}
               options={{headerShown: false}}
            />
         </Stack.Navigator>
         {showLandscapeMsg &&
            (isLandscapeSmallWebView || isTabletPortraitMode) && (
               <CustomToast message={rotateDeviceMsg} />
            )}
      </View>
   );
};

export default AuthNavigator;
